// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__11nkI","col":"styles_col__1K5rY","fulfillmentStatus":"styles_fulfillmentStatus__2b4u-","emailCol":"styles_emailCol__27drS"};